import React from 'react'
import './styles.scss'
import { SparkLineCH } from 'components/sparkLineCH'
import { SparkLineUSA } from 'components/sparkLineUSA'
import { SparkLineChina } from 'components/sparkLineChina'
import { SparkLineMarokko } from 'components/sparkLineMarokko'
import { SparkLineNorway } from 'components/sparkLineNorway'
import { SparkLineRussia } from 'components/sparkLineRussia'
import { SparkLineSaudiaArabia } from 'components/sparkLineSaudiaArabia'
import { SparkLineJapan } from 'components/sparkLineJapan'
import { SparkLineEU } from 'components/sparkLineEU'
import { SparkLineIndia } from 'components/sparkLineIndia'

export function SparkLineWrapper(props) {
  if (props.country === 'USA') {
    return (
      <div className='sparkLineContent'>
        <p>
          Der zweitgrösste CO₂-Produzent gehörte in Paris zur sogenannten High
          Ambition Coalition, die den Verhandlungsprozess an der Klimakonferenz
          prägte. Dann kam jedoch alles anders: Unter der Regierung von Donald
          Trump traten die USA aus dem Klimavertrag aus. Der Präsident unternahm
          alles, um die unter Barack Obama gestärkte Klimapolitik wieder zu
          schwächen. So hob er zum Beispiel verschiedene Regulierungen, welche
          eine Reduktion der CO₂-Emissionen im Verkehr und einen Ausstieg aus
          der Kohlen- und Erdölenergie begünstigten, auf.{' '}
        </p>
        <p>
          Das Klimaziel im Rahmen des Pariser Vertrags war , bis 2030 die
          Treibhausgase um 26 bis 28 Prozent unter das Niveau von 2005 zu
          senken. Dank Corona werden die Staaten dieses Ziel vermutlich
          erreichen. Nun weht jedoch wieder ein anderer Wind in den Staaten,
          seit der neue demokratische Präsident Joe Biden an der Macht ist. Die
          USA anerkennen das Pariser Abkommen wieder und Biden hat Grosses vor
          im Klimaschutz. So will er so schnell wie möglich aus der fossilen
          Energiegewinnung aussteigen. Die USA will bis 2030 die Emissionen um
          50 bis 52 Prozent gegenüber 2010 senken. Ohne die Anstrengungen des
          zweitgrössten CO₂-Produzenten nach China würden die globalen
          Emissionen 2030 um 5 bis 10 Prozent höher ausfallen. Dafür will er
          sehr viel Geld in die Hand nehmen. Doch Politik ist kein
          Wunschkonzert, bereits weht ihm Widerstand aus den eigenen Reihen
          entgegen.
        </p>
        <h3 className='graphTitle'>
          Prognose für die Vereinigten Staaten 2030
        </h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineUSA />
      </div>
    )
  }

  if (props.country === 'China') {
    return (
      <div className='sparkLineContent'>
        <p>
          Nach dem Ausstieg der USA aus dem Pariser Klimavertrag unter Präsident
          Trump wurde der weltweit grösste CO₂-Produzent China zum Vorreiter in
          der internationalen Klimapolitik. Im September 2020 hat Präsident Xi
          Jinping die Klimaziele noch etwas verschärft. So soll das Maximum der
          Emissionen bereits vor 2030 erreicht werden, und um 2060 soll das Land
          CO₂-neutral sein. Die Regierung verfolgt auch ein Konjunkturprogramm
          für die Zeit nach der Pandemie, das eine digitale Wirtschaft
          vorantreibt und ein Energiesystem mit erneuerbarer Energie und
          elektrifiziertem Verkehr. Schlagzeilen machte jüngst Chinas
          ankündigung, keine neuen Kohlekraftwerke mehr im Ausland zu
          finanzieren. Unsicher sind Experten allerdings, ob dabei auch jene
          Kraftwerke darunter fallen, die in Planung sind. Das wären doch noch
          mehrere Dutzend.
        </p>
        <p>
          In den letzten Jahren schien es, dass sich die CO₂-Emissionen bereits
          abflachen. Aber als die Pandemie 2020 überwunden schien, wurde die
          Wirtschaft wieder massiv hochgefahren, und die Nachfrage nach Kohle,
          Erdöl und Zement nahm deutlich zu. Das Land will aber in den nächsten
          fünf Jahren den Kohlekonsum drosseln. Der Ausbau von Wind- und
          Solarenergie soll weiter beschleunigt werden. Der Verkauf neuer
          Elektroautos soll in nächsten Jahren massiv gesteigert werden.
          Dennoch: Trotz den Anstrengungen dürften 2030 die Emissionen gegenüber
          2010 um mehr als 20 Prozent höher liegen - das ist nicht
          Paris-kompatibel.
        </p>
        <h3 className='graphTitle'>Prognose für China 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineChina />
      </div>
    )
  }

  if (props.country === 'Indien') {
    return (
      <div className='sparkLineContent'>
        <p>
          Das riesige Land ist der drittgrösste CO₂-Produzent der Welt.
          Allerdings liegen die Pro-Emissionen weit unter dem globalen
          Durchschnitt. Indien gehört zu jenen Entwicklungsländern, welche das
          Emissionsmaximum weniger schnell erreichen müssen als die reichen
          Nationen. Die Regierung hat wegen der Pandemie ein riesiges
          Wirtschaftsförderungspaket geschnürt. Die CAT-Autoren sehen darin eine
          grosse Chance, dass sich das Land nach und nach von der Kohle
          verabschiedet zugunsten erneuerbarer Energien. 2020 sind immerhin
          keine neuen Kohlekraftwerke gebaut worden, dafür stützt die Regierung
          nach wie vor den Kohleabbau und die -produktion. Indien sieht vor, die
          Intensität der Emissionen bis 2030 um gut ein Drittel zu senken. Das
          heisst: den CO₂-Ausstoss bezogen auf die Wirtschaftsleistung.
        </p>
        <p>
          Der Anteil an erneuerbarer Energie im elektrischen System steigt
          stetig. Die Regierung setzt die Bundesstaaten unter Druck, erneuerbare
          Energie zu subventionieren. Jedoch liegt noch kein konkreter Plan vor,
          wie man das fossile Zeitalter verlassen will. Allerdings: Indien ist
          inzwischen weltweit der fünftgrösste Markt für Solar- und Windenergie.
          Tendenz steigend. Indien beteiligt sich gemäss den CAT-Autoren derzeit
          fair am internationalen Klimaschutz, berücksichtigt man die
          wirtschaftlichen Bedingungen und die historische Verantwortung an den
          globalen Emissionen. Aber auch Indien muss bis 2040 aus der Kohlekraft
          ausgestiegen sein, wenn die Klimaziele von Paris erreicht werden
          sollen.
        </p>
        <h3 className='graphTitle'>Prognose für Indien 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineIndia />
      </div>
    )
  }

  if (props.country === 'Schweiz') {
    return (
      <div className='sparkLineContent'>
        <p>
          Die Schweiz verharrt weiterhin in der Kategorie «ungenügend». Zwar hat
          der Bundesrat beschlossen, die Treibhausgasemissionen bis 2030 zu
          halbieren; bis 2050 soll unser Land sogar klimaneutral werden.
          Dennoch, so finden die Forschenden von Climate Tracker, müsste die
          Schweiz als reiche Nation aus Gründen der Fairness einen grösseren
          Beitrag leisten: Mit dem Ansatz einen Teil im Ausland zu reduzieren,
          müsse die Schweiz eigentlich die CO2-Emissionen gegen Null senken, um
          das Klimaabkommen zu erfüllen. Das ist allerdings innert zehn Jahren
          nicht zu realisieren. «Die Schweiz kann jetzt nach der Ablehnung des
          CO₂-Gesetzes ihre Ziele nicht erhöhen», sagt Franz Perrez,
          Umweltbotschafter und Leiter der Delegation in Glasgow. Das Ziel der
          Schweiz sei nicht so schlecht, es sei etwa im Bereich dessen, was der
          Weltklimarat IPCC verlange. «Wichtig ist, dass wir Massnahmen
          beschliessen, um die Ziele auch zu erreichen», sagt Perrez.
        </p>
        <h3 className='graphTitle'>Prognose für die Schweiz 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineCH />
      </div>
    )
  }

  if (props.country === 'Europa') {
    return (
      <div className='sparkLineContent'>
        <p>
          Die Emissionen der Treibhausgase sinken gesamthaft in der Europäischen
          Union. Das EU-Parlament hat das Reduktionsziel verschärft von 40
          Prozent auf mindestens 55 Prozent. Selbst dieses Ziel ist für die
          CAT-Autoren zu tief, wenn man die Wirtschaftskraft und die
          «historische Schuld» gegenüber den Entwicklungsländern in Betracht
          zieht. Das Ziel müsste bei 62 Prozent angesetzt werden. Dann wäre
          die EU «die erste Region, deren offizielles Engagement den Klimazielen
          des Pariser Abkommens entsprechen». Die europäische Kommission hat
          diesen Sommer das «Fit für 55»-Paket präsentiert, um das neue Ziel zu
          erreichen. Die EU-Kommission strebt eine Wasserstoff-Strategie an.
          Dieser neue, klimaschonende Brennstoff könnte im Langstreckenverkehr
          (Lastwagen, Flugzeuge) eine wichtige Rolle spielen. Weiter soll die
          Renovation der Gebäude durch neue Regulierungen vorangetrieben werden.
        </p>
        <p>
          Die CAT-Autoren erwarten, dass durch den Covid-19-Lockdown der
          Wirtschaft die Emissionen in diesem Jahr rund 10 Prozent tiefer liegen
          als im Vorjahr. Für den Abwärtstrend in den letzten Jahren ist
          hauptsächlich die Energiewirtschaft verantwortlich. Kohle wurde
          zunehmend durch WInd- und Solarkraft ersetzt. 2019 betrug der Anteil
          der erneuerbaren Energie in der elektrischen Energieversorgung gut 35
          Prozent. In Schweden und Österreich tendiert der Anteil des
          Kohlestroms gegen null, Spanien hat sieben Kohlekraftwerke
          geschlossen. Setzt die EU den European Green Deal um, dann wird in den
          nächsten Jahren der Einsatz fossiler Treib- und Brennstoffe weiter
          stark reduziert. Die EU-Kommission strebt neu auch eine
          Wasserstoff-Strategie an. Dieser neue, klimaschonende Brennstoff
          könnte im Langstreckenverkehr (Lastwagen, Flugzeuge) eine wichtige
          Rolle spielen. Weiter soll die Renovation der Gebäude durch neue
          Regulierungen vorangetrieben werden. Aber: Der Kohleausstieg wird in
          vielen EU-Mitgliedstaaten nicht bis 2030 passieren. Es gibt Staaten,
          die planen, Kohle durch Erdgas zu ersetzen. Auch fliesst Geld in die
          Infrastruktur von Gas-Infrastruktur. Zwar steigt der Anteil an
          Elektrofahrzeuge, aber vielfach sind es plug-in Hybrid, die mehr
          fossil als elektrisch fahren. Die CAT-Autoren schätzen zudem, dass die
          Renovationsrate auf jährlich 3,5 Prozent steigen muss, um die
          Klimaziele des Pariser Vertrags erreichen zu können. Die EU hat sich
          hingegen dafür ausgesprochen, beim «NextGeneration»-Aufbaufonds (750
          Milliarden Euro) mindestens 37 Prozent für den Klimaschutz
          einzusetzen.
        </p>
        <h3 className='graphTitle'>Prognose für Europa 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineEU />
      </div>
    )
  }

  if (props.country === 'Russland') {
    return (
      <div className='sparkLineContent'>
        <p>
          Das flächenmässig grösste Land der Welt ist ein grosses Sorgenkind im
          internationalen Klimaschutz. In den letzten Jahren gab sich der Staat
          an den internationalen Verhandlungen stets unauffällig, ratifizierte
          2019 das Pariser Abkommen und stellte 2020 einen Entwurf einer
          langfristigen Klimastrategie vor – allerdings ohne Ambitionen.
          Russland ist der viertgrösste CO₂-Produzent weltweit. Die Autoren des
          Climate Action Tracker (CAT) werten Russlands aktualisiertes
          Emissionsziel - mindestens 30 Prozent unter dem Wert von 1990 - als
          “stark ungenügend”.
        </p>
        <p>
          Russland sah bisher auch kein Konjunkturprogramm vor, das nach der
          Pandemie die Wirtschaft auf einen nachhaltigen, klimaschonenden Pfad
          bringen soll. Im Gegenteil: Das Land setzt weiterhin auf fossile
          Energie, vor allem soll der Gasexport weiter ausgebaut werden. Der
          Anteil an Solar- und Windenergie in der russischen Energieversorgung
          werde in zwanzig Jahren nicht viel mehr als 1 Prozent betragen,
          erwarten Wissenschaftler der Moscow School of Management in einem
          Aufsatz im Fachmagazin «Energy Transitions». Die Autoren des CAT
          erwarten einen Anstieg der Emissionen. Selbst wenn die Regierung das
          Klimaziel bei einer Reduktion der Treibhausgase um 33 Prozent
          gegenüber 1990 festlegt. Dazu braucht es keine zusätzlichen
          Massnahmen, weil das Land dieses Level schon fast erreicht hat.
        </p>
        <h3 className='graphTitle'>Prognose für Russland 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineRussia />
      </div>
    )
  }

  if (props.country === 'Saudiarabien') {
    return (
      <div className='sparkLineContent'>
        <p>
          Der Erdölstaat hat das Pariser Abkommen ratifiziert. Aber er zeigte
          bisher keinerlei grosse Anstrengungen im Klimaschutz. So versuchte das
          Land auch dieses Jahr, die internationalen Gespräche über die
          Aufhebung der Subventionen für fossile Energie zu verhindern. Es
          werden immer noch Hunderte Milliarden Dollar jährlich in die
          Verbilligung von Kohle, Gas und Erdöl investiert. Saudiarabien ist in
          den Top Ten der grössten CO₂-Produzenten.
        </p>
        <p>
          Der Erdölproduzent musste den Export von Rohöl 2020 massiv senken.
          Saudiarabien hat ebenfalls Massnahmen ergriffen, um die Wirtschaft zu
          stärken, aber ohne jeglichen Anspruch an den Klimaschutz. Die
          Projektionen für die Emissionen von 2030 gehen von einer Reduktion von
          6 bis 9 Prozent bis 2030 aus. Nun hat das Land strengere Ziele
          gesetzt. Was das allerdings heisst, muss erst vom Team des Climate
          Tracker analysiert werden. Der Erdölstaat hat auch seine Ambitionen,
          in die Kernenergie zu investieren, zurückgeschraubt. Die Sonnenenergie
          wächst in diesem sonnenreichen Staat nur langsam.
        </p>
        <h3 className='graphTitle'>Prognose für Saudiarabien 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineSaudiaArabia />
      </div>
    )
  }

  if (props.country === 'Marokko') {
    return (
      <div className='sparkLineContent'>
        <p>
          Das nordafrikanische Land ist eines der wenigen Entwicklungsländer,
          die fähig wären, die CO₂-Emissionen zu senken. Die Ausbreitung
          erneuerbarer Energie, vor allem Wind- und Solarkraft, geht
          kontinuierlich voran. Aber Marokko plant den Bau neuer Gaskraftwerke.
          Noch immer stammt ein Grossteil der Energieproduktion von Kohle. Das
          Land darf aber aufgrund seiner wirtschaftlichen Bedingungen und der
          geringen historischen Verantwortung für die Emissionen in den nächsten
          Jahren noch einen Anstieg der Emissionen verbuchen. Das Wachstum ist
          aber derart, dass der Beitrag am internationalen Klimaschutz den
          Anforderungen des Pariser Abkommens entspricht. Bis 2030 will Marokko
          den Anteil der erneuerbaren Energie an der Gesamtproduktion
          elektrischer Energie auf rund 50 Prozent steigern. Das Land will auch
          in die Produktion von grünem Wasserstoff (Herstellung mithilfe von
          Solarenergie) einsteigen. Marokko hat in diesem Zusammenhang mit
          Deutschland einen Kooperationsvertrag abgeschlossen.
        </p>
        <h3 className='graphTitle'>Prognose für Marokko 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineMarokko />
      </div>
    )
  }

  if (props.country === 'Japan') {
    return (
      <div className='sparkLineContent'>
        <p>
          Der Inselstaat ist der fünftgrösste CO₂-Produzent der Welt. In den
          letzten Jahren zeigte der Emissionstrend allerdings deutlich nach
          unten. Und die Pandemie hat den Abwärtstrend zumindest für 2020
          verstärkt. Das Land will aus ineffizienten Kohlekraftwerken aussteigen
          und Offshore-Windkraft fördern. Trotzdem war ist das Klimaziel für
          2030 mit einer Reduktion der Emissionen von 26 Prozent gegenüber 2013
          sehr gering. Nun hat Japan nachgebessert: Bis 2030 sollen nun die
          Emissionen gegenüber 2013 um 48 Prozent fallen. Wie Japan allerdings
          schaffen will ist noch unklar. So will das Land bis 2030 nicht
          vollständig aus der Kohle aussteigen, und ob der erwartete Anteil an
          Kernkraft in der Energieversorgung erreicht wird, ist wegen der
          schwindenden Akzeptanz auch fraglich.
        </p>
        <h3 className='graphTitle'>Prognose für Japan 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineJapan />
      </div>
    )
  }

  if (props.country === 'Norwegen') {
    return (
      <div className='sparkLineContent'>
        <p>
          Das kleine Land gilt eigentlich als Musterknabe. Dieses Jahr hat es
          beschlossen, die CO₂-Emissionen bis 2030 mindestens um 50 Prozent
          unter das Niveau von 1990 zu senken. Die norwegische Pensionskasse hat
          beschlossen, keine Investitionen mehr für die Erdöl- und
          Erdgasförderung und -produktion zu tätigen, sie will sogar ihr Geld
          aus acht Kohleunternehmen herausnehmen. Das Gesetz verbietet unter
          anderem, in Unternehmen zu investieren, die in grossem Stil Kohlestrom
          produzieren. Norwegen fördert auch stark die Elektrifizierung des
          Verkehrs. In keinem anderen Land fahren so viele Elektroautos. Dennoch
          geben die CAT-Autoren Norwegen nicht Bestnoten im Klimaschutz. Das
          Land könnte noch mehr tun, andere Staaten planen verhältnismässig
          mehr. Das Ziel reicht nicht, um das 1.5-Grad Ziel zu erreichen. Noch
          immer fördert das Land Erdöl und Erdgas. Noch fehlt auch eine
          Strategie, wie das Land CO₂-neutral werden will.
        </p>
        <h3 className='graphTitle'>Prognose für Norwegen 2030</h3>
        <div className='subtitle'>
          Treibhausgasemissionen in Megatonnen CO₂ pro Jahr
        </div>
        <div className='legend'>
          <img src={require('../../images/legend-kurs.svg')}></img>
          <span>aktueller Kurs</span>
        </div>
        <SparkLineNorway />
      </div>
    )
  }

  // if (props.name === 'China') {
  //   return (

  //   )
  // }

  return null
}
